import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Sensor } from './../models/sensor.model';
import { environment } from '../../../environments/environment';


/**
 * Service to use the API nodes related calls.
 */
@Injectable()
export class SensorService {
  /**
   * Build the component and initialize certain attributes.
   * @param {HttpClient} http Service to make API calls.
   */
  constructor(private http: HttpClient) { }

  /**
   * Sends a node to store it in the backend.
   * @param {Sensor} data Sensor to be stored.
   */
  create(data: Sensor) {
    return this.http.post(`${environment.apiUrl}/devices`, data);
  }
  /**
   * Updates a node in the backend.
   * @param {string} id Sensor ID.
   * @param {Sensor} data Sensor to be updated.
   */
  update(id: string, data: Sensor) {
    return this.http.put(`${environment.apiUrl}/devices/${id}`, data);
  }
  /**
   * Deletes a node in the backend.
   * @param {string} id Sensor ID.
   */
  delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/devices/${id}`);
  }
  /**
   * Gets one Sensor from the backend.
   * @param {string} id Sensor ID.
   */
  show(id: string) {
    return this.http.get(`${environment.apiUrl}/devices/${id}`);
  }
  /**
   * Gets Sensors filtering by certain parameters.
   * @param params Parameters to filter the query.
   */
  showAll(params: any = {}) {
    return this.http.get(`${environment.apiUrl}/devices`, { params: params });
  }

  /**
   * Get a list of node types
   * @param params Parameters to filter the query.
   */
  getTypes(params: any = {}) {
    return this.http.get(`${environment.apiUrl}/devices/schemes`, { params: params });
  }

}
